export default "__VITE_ASSET__BExF_IKi__"